import React from 'react';

import { useLocation } from 'react-router-dom';

import { StyledNavLink } from '../Header/NavLink.styled';
import { StyledBreadcrumb } from './Breadcrumbs.styled';

const Breadcrumb = () => {
  const location = useLocation();
  const pathNames = location.pathname.split('/').filter((el) => el);

  return (
    <StyledBreadcrumb aria-label="breadcrumb">
      <StyledNavLink to="/" end>
        Home
      </StyledNavLink>
      {pathNames.map((e, i) => {
        const destination = `/${pathNames.slice(0, i + 1).join('/')}`;
        const labelLow = e.replaceAll('-', ' ');
        const labelCap = labelLow[0].toLocaleUpperCase() + labelLow.slice(1);
        return (
          <React.Fragment key={e + i}>
            <span>/</span>
            <StyledNavLink to={destination} end>
              {labelCap}
            </StyledNavLink>
          </React.Fragment>
        );
      })}
    </StyledBreadcrumb>
  );
};

export default Breadcrumb;
